import React, { useState, useEffect } from "react";
import { Table, Row, Col, Card, CardBody, Alert, Badge, Label, Button } from "reactstrap"
import { get, post } from "../../helpers/api_helper";
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { Trans } from 'react-i18next';
import { Link, useLocation, useNavigate } from "react-router-dom";
import Loader from "common/loader";
import { ROLES, MODULES_LIST, SHOW_ROLE, PERMISSIONS, ASSIGN_PERMISSION } from "helpers/api_endpoints";
import Select from "react-select";
//meta title
document.title = "Roles Permissions";
const RolesList = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [loading, setLoading] = useState(true);
    const [roles, setRoles] = useState([]);
    const [modules, setModules] = useState([]);
    const [permissions, setPermissions] = useState([]);
    const [roleId, setRoleId] = useState(null);
    const [role, setRole] = useState(null);
    const [moduleId, setModuleId] = useState(null);
    const [screenId, setScreenId] = useState(null);
    const [successMsg, setsuccessMsg] = useState('');

    useEffect(() => {
        successMessage();
        get(MODULES_LIST)
            .then(response => {
                const data = response.data;
                setModules(data);
                setLoading(false);
            })
            .catch(error => {
                if (error.response.status == 401) {
                    navigate('/logout');
                }
            })
        get(PERMISSIONS)
            .then(response => {
                const data = response.data;
                setPermissions(data);
                setLoading(false);
            })
            .catch(error => {
                if (error.response.status == 401) {
                    navigate('/logout');
                }
            })
    }, []);

    useEffect(() => {
        successMessage();
        get(ROLES)
            .then(response => {
                const data = response.data;
                setRoles(data.map(role => ({ value: role.id, label: role.name })));
                setRole(data.find(r => r.id === roleId));
                setLoading(false);
            })
            .catch(error => {
                if (error.response.status == 401) {
                    navigate('/logout');
                }
            })
    }, [roleId]);


    const successMessage = () => {
        if (location.state) {
            setsuccessMsg(location.state.successMsg);
            setTimeout(() => {
                setsuccessMsg('');
            }, 4000)
        }
    };

    const handleRoleId = (value) => {
        setRoleId(value);
    };

    const changePerm = (screenId, permissionId, isAssigned) => () => {
        console.log("Screen ID:", screenId, "Permission ID:", permissionId, "Is Assigned:", isAssigned);
        post(ASSIGN_PERMISSION, { roleId, screenId, permissionId, status: !isAssigned ? '1' : '2' })
            .then(response => {
                get(SHOW_ROLE + `/${roleId}`)
                    .then(response => {
                        const data = response.data;
                        setRole(data);
                        console.log("Updated Role Data:", data);
                        setLoading(false);
                    })
                    .catch(error => {
                        if (error.response.status == 401) {
                           
                        }
                    })
                setLoading(false);
            })
            .catch(error => {
                if (error.response.status == 401) {
                    
                }
            })
        // if(isAssigned){
        //     role.Permissions.splice(role.Permissions.indexOf(role.Permissions.find(perm => perm.id == permissionId && perm.RolePermission.ScreenId == screenId)), 1);
        // } else {
        //     const temp = Object.assign({}, role);
        //     temp.Permissions.push({id: permissionId, RolePermission: {ScreenId: screenId}});
        //     setRole(temp);
        // }
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <div className="container-fluid">
                    <Breadcrumbs title="Home" breadcrumbItem="Roles Permissions" />
                    <Row>
                        <Col xl={12}>
                            <Card>
                                <br></br>
                                {successMsg ? <Alert style={{ margin: "25px" }} color="success">{successMsg}</Alert> : null}
                                {/* <Link to="/roles/add" >
                                    <button style={{ float: "right", marginRight: "20px" }} className="btn btn-sm btn-primary"><i className="dripicons-plus"></i> &nbsp;<Trans>Create</Trans></button>
                                </Link> */}
                                <Row>
                                    <div className="form-group col-md-3 mt-2">
                                        <Label className="form-label"><Trans>Choose Roles</Trans></Label>
                                            <Select
                                                name="roleId"
                                                value={roles.find(el => el.value === roleId)}
                                                options={roles} 
                                                className="form-control select2"
                                                onChange={(e) => handleRoleId(e.value)}
                                            />
                                    </div>
                                </Row>

                                <CardBody>
                                    <div className="table-responsive">
                                        <Table className="table table-striped table-bordered mb-0">
                                            <thead>
                                                <tr>
                                                    <th><Trans>Id</Trans></th>
                                                    <th colSpan={2}><Trans>Name</Trans></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {loading ? <tr><th colSpan={6} className="text-center"><Loader></Loader></th></tr> : null}
                                                {
                                                    modules.map((module, index) => (
                                                        <tr key={index}>
                                                            <td>{module.id}</td>
                                                            <td className="fw-bold">{module.name}</td>
                                                            <td>
                                                                <Table className="table table-striped table-bordered mb-0">
                                                                    <thead>
                                                                        <tr>
                                                                            <th><h4><Badge className="bg-warning " >Screen Name</Badge></h4></th>
                                                                                {permissions.map((permission, permIndex) => (
                                                                                    <td key={permIndex}>
                                                                                        <h5><Badge className="bg-success " >{permission.name}</Badge></h5>
                                                                                    </td>
                                                                                ))}
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {module.screen.map((screen, idx) => (
                                                                            <tr key={idx}>
                                                                                <td className="fw-bold">{screen.name}</td>
                                                                                {permissions.map((permission, permIndex) => (
                                                                                    <td key={permIndex}>
                                                                                        <input
                                                                                            type="checkbox"
                                                                                            checked={(role?.RolePermissions.find(el => (el.PermissionId == permission.id && el.ScreenId == screen.id))??false != false)}
                                                                                            onClick={changePerm(screen.id, permission.id, role?.RolePermissions.find(el => (el.PermissionId == permission.id && el.ScreenId == screen.id))??false)}
                                                                                        />
                                                                                    </td>
                                                                                ))}
                                                                            </tr>
                                                                        ))}
                                                                    </tbody>
                                                                </Table>
                                                            </td>
                                                        </tr>
                                                    ))
                                                }
                                            </tbody>
                                        </Table>
                                    </div>
                                    {/* <div className="mt-4">
                                        <Button type="submit" color="primary" onClick={false}>
                                            <Trans>Submit</Trans>
                                        </Button>
                                    </div> */}

                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </div>
            </div>
        </React.Fragment>
    )
}

export default RolesList
